export default function fieldQuantity({main, on, elm, state, emit}) {
	main(_ => {
		on('click', '[data-increase]', increaseQuantity);
		on('click', '[data-decrease]', decreaseQuantity);
		on('change', '.cart-product__quantity-inp', onChange);
	});

	const increaseQuantity = function() {
		const {quantity} = state.get();

		const newQuantity = quantity + 1;
		state.set(s => s.quantity = newQuantity);
		emit('quantity-changed', newQuantity);
	};

	const decreaseQuantity = function() {
		const {quantity} = state.get();
		if (quantity <= 1) return;

		const newQuantity = quantity - 1;
		state.set(s => s.quantity = newQuantity);
		emit('quantity-changed', newQuantity);
	};

	const onChange = function(e) {
		const quantity = +e.target.value;

		state.set(s => s.quantity = quantity);
		emit('quantity-changed', quantity);
	};
};

export const model = ({elm}) => {
	const quantity = Number.parseInt(elm.dataset.quantity);

	return {
		quantity,
	}
}
